import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    formControl: {
      paddingTop: 13,
      [theme.breakpoints.up("mobile")]: {
        paddingTop: 16,
      },
      [theme.breakpoints.up("tablet")]: {
        paddingTop: 25,
      },
    },
  }),
  { name: "CountrySelect" },
);
